import { useEffect, useState } from 'react';

/**
 * Set boolean state that can be returned to "false" manually or by timeout
 */
export const useActiveStateWithTimeoutHook = ({
    timeoutMs,
}) => {
    const [isActive, setIsActive] = useState(false);
    const [timer, setTimer] = useState(0);

    const deactivate = () => {
        setIsActive(false);
        clearTimeout(timer);
        setTimer(0);
    };

    const activate = () => {
        setIsActive(true);
        clearTimeout(timer);
        setTimer(setTimeout(deactivate, timeoutMs));
    };

    // clear timer on destroy
    useEffect(() => {
        return () => {
            clearTimeout(timer);
        };
    }, [timer]);

    return {
        isActive,
        deactivate,
        activate,
    };
};
